import React, { useState } from 'react';

type Option = {
  value: string;
  label: string;
};

type SelectBoxProps = {
  id: string;
  options: Option[];
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  label?: string;
  className?: string;
  placeholder?: string;
  isFlat?: boolean;
  disabled?: boolean;
};

const SelectBox: React.FC<SelectBoxProps> = ({
  id,
  options,
  value,
  onChange,
  label,
  className = "",
  placeholder = "",
  isFlat = false,
  disabled = false,
}) => {
  const [selected, setSelected] = useState(value);
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelected(e.target.value);
    onChange?.(e);
  };
  const divClass = isFlat ? 'selectbox-flat' : '';
  const selectClass =
    selected && selected !== ''
      ? 'selectbox-select selected'
      : 'selectbox-select';

  return (
    <div className={divClass}>
      {label && (
        <label htmlFor={id} className="selectbox-label">
          {label}
        </label>
      )}
      <select
        id={id}
        value={selected}
        onChange={handleChange}
        disabled={disabled}
        className={`${selectClass} ${className}`}
      >
        {placeholder && (
          <option value="">
            {placeholder}
          </option>
        )}
        {options.map(opt => (
          <option
            key={opt.value}
            value={opt.value}
          >
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectBox;
